<script>
    /*
    	SlidingSortFields.svelte
    */

    import { onMount } from 'svelte';
    import { fly, fade } from 'svelte/transition';

    // TCARE components
    import SortField from './SortField.svelte';

    export let isFieldsOpen;
    export let onSort;              // on ResourceExplorerPage

    onMount(() => {
    })

</script>

<style>
    .sort-fields-wrapper {
        width: 220px;
        height: 20px;
        overflow: hidden;
        /* border: 1px solid green; */
    }

    .sort-fields {
        width: 220px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 13px;
        font-weight: 500;
        color: #A075A5;        
        /* border: 1px solid red; */
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="sort-fields-wrapper">
    {#if isFieldsOpen}
        <div class="sort-fields" in:fly="{{ x: 200, duration: 250 }}" out:fly="{{ x: 200, duration: 250 }}" >
            <SortField label={'Service Name'} propName={'service-name'} {onSort} />
            <SortField label={'Rating'} propName={'average-rating'} {onSort} />
        </div>
    {/if}
</div>
